"use client";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import Image from "next/image";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckIcon from "@mui/icons-material/Check";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { FormatedTime } from "../formated-time/FormatedTime";
import { AddToCartService } from "../../../services/cart";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import { useEffect, useMemo, useState } from "react";
import MaxServiceAlert from "./MaxServiceAlert";

const mint = "#1f7a4d";
const mintGradient = "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)";
const mintGradientHover = "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)";

interface CardRsOneServiceProps {
  childId: any;
  cid: any;
  item: any;
  viewDetailsData: any;
  updateCard: any;
  setUpdateCard: any;
}

export const CardRsOneService: React.FC<CardRsOneServiceProps> = ({
  childId,
  cid,
  item,
  viewDetailsData,
  updateCard,
  setUpdateCard,
}) => {
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const [isClicked, setIsClicked] = useState(false);
  const [openMaxService, setOpenMaxService] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setVaue] = useState(1);
  const currencyCode = useCurrencyCode();

  const handleOpenViewDetails = (item: any) => {
    viewDetailsData(item);
  };

  useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(childId, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [childId, updateCard, addToCartService, cid, setUpdateCard]);

  const handleClickButton = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      childId,
      true,
      cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setIsLoading(false);
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      childId,
      false,
      cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      childId,
      true,
      cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setIsLoading(false);
    }
  };

  // const handleAddGift = (e) => {
  //   e.stopPropagation();
  //   try {
  //   } catch (e) {}
  // };

  return (
    <>
      <Box
        // onClick={() => handleOpenViewDetails(item)}
        sx={{
          minWidth: "17rem",
          minHeight: "20rem",
          width: "17rem",
          height: "20rem",
          borderRadius: "1rem",
          overflow: "hidden",
          position: "relative",
          margin: { xs: "0.5rem auto", sm: "1rem auto" },
          boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Image
          src={item?.coverImage?.secureHttpPath}
          width={500}
          height={500}
          style={{
            margin: "auto",
            objectFit: "cover",
            width: "17rem",
            height: "20rem",
            borderRadius: "1rem",
            background:
              "linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 25%, rgba(0, 0, 0, 0))",
          }}
          alt="category"
        />
        <Box
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "80%",
            background:
              "linear-gradient(to top, rgba(0, 0, 0, 0.8) 75%, rgb(255 255 255 / 0%))",
          }}
        >
          <Box
            sx={{
              textAlign: "left",
              padding: "12px",
              bottom: 0,
              position: "absolute",
              width: "-webkit-fill-available",
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "white", marginBottom: "-4px" }}
            >
              {item?.name}
            </Typography>
            <Typography variant="caption" sx={{ color: "white" }}>
              {item?.subHeading}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                color: "white",
              }}
            >
              <WatchLaterIcon sx={{ fontSize: "16px" }} />
              <Typography variant="caption" sx={{ paddingLeft: "8px" }}>
                <FormatedTime min={item?.min} />
              </Typography>
            </Box>
            <Box
              sx={{
                maxHeight: "7rem",
                //   minHeight: "7rem",
                overflow: "scroll",
                "&:: -webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {item?.aboutList?.map((nestedItem: any, index: number) => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "start",
                  }}
                  key={index}
                >
                  <CheckIcon
                    sx={{
                      color: "white",
                      paddingRight: "5px",
                      fontSize: "1rem",
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ color: "white", fontSize: "11px" }}
                  >
                    {nestedItem}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px",
                overflow: "auto",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: currencyCode == "NPR" ? "12px" : "14px",
                }}
              >
                <span
                  style={{
                    color: "#ffbf00",
                    fontWeight: "bold",
                  }}
                >
                  {currencyCode}
                  {item?.amount?.toLocaleString()}/-
                </span>{" "}
                &nbsp;
                <span
                  style={{
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  Save {currencyCode}
                  {item?.discount?.toLocaleString()}/-
                </span>{" "}
                &nbsp;
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "#ffbf00",
                  }}
                >
                  {currencyCode}
                  {item?.mrp?.toLocaleString()}/-
                </span>
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="outlined"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "6px 20px",
                  borderRadius: "10rem",
                  width: "115px",
                  boxShadow: "none",
                  color: "white",
                  border: "1px solid rgba(255,255,255,0.85)",
                  "&:hover": {
                    border: "1px solid #fff",
                    background: "rgba(255,255,255,0.12)",
                  },
                }}
                onClick={() => handleOpenViewDetails(item)}
              >
                View Details
              </Button>
              {isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "115px",
                    background: "none",
                    borderRadius: "10rem",
                    border: `1px solid ${mint}`,
                  }}
                >
                  <CircularProgress size="25px" sx={{ color: mint }} />
                </Box>
              ) : isClicked ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    width: "115px",
                    background: mintGradient,
                    borderRadius: "10rem",
                    color: "white",
                  }}
                >
                  <RemoveIcon
                    onClick={handleValueDecrease}
                    sx={{ cursor: "pointer" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {value}
                  </Typography>
                  <AddIcon
                    onClick={handleValueIncrease}
                    sx={{ cursor: "pointer" }}
                  />
                </Box>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "11px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    padding: "6px 20px",
                    borderRadius: "10rem",
                    width: "115px",
                    boxShadow: "0 4px 14px rgba(18, 53, 36, 0.2)",
                    background: mintGradient,
                    "&:hover": { background: mintGradientHover },
                  }}
                  onClick={handleClickButton}
                >
                  Add to Cart
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
    </>
  );
};
